import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import Registration from '../Auth/Registration';
import NotFound from '../Pages/NotFound';
import EMSRegistration from '../Auth/ems-Registration';


export default class AppRouters extends Component {
   
    render() {
        return (
            <div>
                <Router>
                    <Routes>
                        <Route path="/" element={<Registration />} />
                            <Route path="/Registration" element={<Registration />} />
                            <Route path="/ems/register" element={<EMSRegistration />} />
                            <Route path="*" element={<NotFound />} /> 
                    </Routes>
                </Router>
            </div>
        )
    }
    
}
